export default __webpack_public_path__ + "static/03-BEBIDAS_REFRESCANTES--9b38fb375eebfcca245d2e606ca08c71.jpg";